import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
// import { Button } from "@mui/material";
import { incrementItemCountInCart, decrementItemCountInCart } from '../../redux/purchaseRequest/purchaseRequestSlice';
// import Button from "@material-ui/core/Button";
// import AddIcon from "@material-ui/icons/Add";
// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
// import RemoveIcon from "@material-ui/icons/Remove";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


const PurchaseQuantity = ({ currentItem }) => {
    const dispatch = useDispatch();


    // calculateTotal:(state) =>{
    //     let amount=0;
    //     let subTotal=0;
    //     state.currentItem.forEach((item) => {
    //         amount+=item.amount;
    //         subTotal+=item.amount*item.price;
    //     });

    //     state.amount=amount;
    //     state.subTotal=subTotal;
    // }

    const IncrementQuantity = () => {
        const updatedItem = {
            ...currentItem,
            quantity: currentItem.quantity + 1,
            subtotal: currentItem.price * (currentItem.quantity + 1),
        }
        // dispatch an action to store
        dispatch(incrementItemCountInCart(updatedItem));
    };

    const DecrementQuantity = () => {
        if (currentItem.quantity > 1) {
            const updatedItem = {
                ...currentItem,
                quantity: currentItem.quantity - 1,
                subtotal: currentItem.price * (currentItem.quantity - 1),
            }
            // dispatch an action to store
            dispatch(decrementItemCountInCart(updatedItem));
        }

    };

    const handleCountInputChange = (e) => {
        const { value } = e.target;
        const updatedItem = {
            ...currentItem,
            quantity: value,
            subTotal: currentItem.price * value,
        }
        // dispatch an action to store
        dispatch(incrementItemCountInCart(updatedItem));
    }

    return (
        <div style={{ display: 'flex', maxWidth: 200 }}>
            {/* <Button onClick={() => DecrementQuantity()} style={{color: "#434343"}}>
               <RemoveIcon />
            </Button>
            <input type="number" min="1" max="10" style={{ width: 60, height: 30 }} value={currentItem?.quantity} onChange={(e) => handleCountInputChange(e)} />
            <Button onClick={() => IncrementQuantity()} style={{color: "#434343"}}>
                <AddIcon />
            </Button> */}
            <ButtonGroup>
                <Button
                    aria-label="reduce"
                    onClick={() => DecrementQuantity()}
                >
                    <RemoveIcon fontSize="small"  />
                </Button>
                <input type="number" min="1" max="10" disabled style={{ width: 45, height: 33, borderColor: '1px solid #DEE2E7',display:"flex",justifyContent:"center",alignItems:"center" }} value={currentItem?.quantity} onChange={(e) => handleCountInputChange(e)} />
                <Button
                    aria-label="increase"
                    onClick={() => IncrementQuantity()}
                >
                    <AddIcon fontSize="small" />
                </Button>
            </ButtonGroup>
        </div>
    );
};

export { PurchaseQuantity };
